import { OrganizationCalendarI } from "@interfaces/organizationI";
import { RootState } from "@redux/store";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

interface IOrganizationListItemProps
{
    org: OrganizationCalendarI,
    onClick: (org: OrganizationCalendarI) => void
}

const OrganizationListItem = (props: IOrganizationListItemProps) => {
    const { org, onClick } = props
    const { t } = useTranslation(["sessionCard", "organization"]);
    const organizationRedux = useSelector((state: RootState) => state.organizations);
    
    return (
        <>
            <div className="HeaderUser__Info">
                <p className="HeaderUser__Text" style={{ display: "flex", gap: "4px", justifyContent: "center", alignItems: "center"}}>
                    {organizationRedux.organizationId === org.organizationId &&
                        <em className="fad fa-check-circle" style={{fontSize:"18px"}}></em>
                    }
                    {org.organizationName}
                </p>
                {
                    org.statusCode === "ACTIVE" ?
                <>
                <div className="Services__TableHeaderItem3" style={{gridGap: "0", alignItems: "center"}}>
                    { org.roles?.map((rol) => (
                        <p key={rol}>
                            { t(`organization:organization.users.row.roles.${rol}`) }
                        </p>
                    ))
                    }
                </div>
                {organizationRedux.organizationId !== org.organizationId ?
                    <span className="HeaderUser__Link" onClick={() => onClick(org)} > 
                        { org.organizationType === null ?  t("goToPrivatePractice") : t("goToOrganization") } 
                    </span>
                    : 
                    null
                }
                </>
                :
                    <p>{t(`organization:organization.users.row.status.${org.statusCode}`)}</p>
                }
            </div>
            <span className="Divider"/>
        </>
    )
}

export default OrganizationListItem
